// tune default api-cnig SelectionPlugin.
// it allows to select a single cell, a building, by polygon or communities.
class SelectionPlugin {
    constructor() {

        this.SELECTION_TOOL_COMMUNITY = 0;
        this.SELECTION_TOOL_POLYGON = 1;
        this.SELECTION_TOOL_POINT = 2;
        this.SELECTION_TOOL_BUILDING = 3;
        this.SELECTION_TOOL_FILE = 4;

        this.SELECTION_MODE_ADD = false;
        this.SELECTION_MODE_SUBSTRACT = true;
        this.current_selected_tool = this.SELE;
        this.current_toggle_mode = this.SELECTION_MODE_ADD;

        // add custom buttons icons and handle their events
        $(document).ready(function () {

            $("#polygon").after(`
                <button>
                    <i id="community" data-type="community" class="tool" title="Comunidad energética"></i>
                </button>
            `);
            $("#polygon").after(`
                <button id="polygon-tool">
                    <i id="polygon-plus" data-type="polygon" data-mode="add" class="tool" title="Añadir polígono"> </i>
                    <i id="polygon-less" data-type="polygon" data-mode="sub" class="tool" title="Eliminar polígono"> </i>
                </button>
            `);
            
            $('#polygon').after(`
                <button id="points-tool">
                    <i id="dot-plus" data-type="point" data-mode="add" class="tool" title="Añadir punto"> </i>
                    <i id="dot-less" data-type="point" data-mode="sub" class="tool" title="Eliminar punto"> </i>
                </button>
            `);
            $("#polygon").after(`
                <button id="building-tool">
                    <i id="building-plus" data-type="building" data-mode="add" class="tool" title="Añadir edificio"> </i>
                    <i id="building-less" data-type="building" data-mode="sub" class="tool" title="Eliminar edificio"> </i>
                </button>
            `);

            $("#div-contenedor").addClass("d-flex");
            $(".m-panel-btn.g-cartografia-flecha-derecha").addClass("h-100");

            // handle events
            $(".tool").click(function () {

                // handle active the buttons
                const button = $(this);
                const previusly_activated = button.hasClass("activated");

                // remove activations to everyone
                $(".tool").removeClass("activated");

                // if not activated previously, add activate class
                if (!previusly_activated) {
                    button.addClass("activated");
                }                   

                // get tool type and mode
                const tooltype = button.data("type");
                const toolmode = button.data("mode");

                // set mode
                selection_plugin.set_mode(tooltype, toolmode);

                // if community, click on it
                if (tooltype === 'community' && $('#community').hasClass("activated")) {
                    selection_plugin.click_community_button();

                    // set community sidebar
                    //selection_plugin.render_sidebar_community(); lo comento porque está función no está definida y da error, debe ser una función anterior
                    
                    // set filters sidebar
                    uncollapseSidebar();
                } else {
                    // if clicked in any other, and the point (community) is still selected, unselect it
                    if (selection_plugin.is_plugin_point_selected()) {
                        selection_plugin.click_community_button();
                    }

                    // set filters sidebar
                    uncollapseSidebar();
                }

                if (tooltype === 'polygon' && ($('#polygon-plus').hasClass("activated")) || ($('#polygon-less').hasClass("activated"))) {
                    if (!selection_plugin.is_plugin_polygon_selected()) {
                        $("#polygon").click();
                    }
                } else {
                    // if clicked any other, and the point is still selected, unselect it
                    if (selection_plugin.is_plugin_polygon_selected()) {
                        $("#polygon").click();
                    }
                }



            });
            $(".m-panel-btn.g-cartografia-flecha-derecha").click(function () {
                if ($("#referencia-catastral").hasClass("d-none")) 
                    $("#referencia-catastral").removeClass("d-none");
                else 
                    $("#referencia-catastral").addClass("d-none");
            });

            // set as default
            $("#building-plus").click();
        });

    }

    click_community_button() {
        $("#point").click();
    }

    // set
    set_mode(type, mode) {
        $(".tutorial").addClass("d-none")
        switch (mode) {
            case 'add':
                selection_plugin.current_toggle_mode = selection_plugin.SELECTION_MODE_ADD;
                break;
            case 'sub':
                selection_plugin.current_toggle_mode = selection_plugin.SELECTION_MODE_SUBSTRACT;
                break;
        }
        switch (type) {
            case 'point':
                $("#point-searcher-collapse").removeClass("d-none");
                selection_plugin.current_selected_tool = selection_plugin.SELECTION_TOOL_POINT;
                break;
            case 'polygon':
                $("#polygon-searcher-collapse").removeClass("d-none");
                selection_plugin.current_selected_tool = selection_plugin.SELECTION_TOOL_POLYGON;
                break;
            case 'building':
                $("#building-searcher-collapse").removeClass("d-none");
                selection_plugin.current_selected_tool = selection_plugin.SELECTION_TOOL_BUILDING;
                break;
            case 'community':
                $("#community-collapse").removeClass("d-none");
                selection_plugin.current_selected_tool = selection_plugin.SELECTION_TOOL_COMMUNITY;
                break;
            case 'file':
                $("#file-searcher-collapse").removeClass("d-none");
                selection_plugin.current_selected_tool = selection_plugin.SELECTION_TOOL_FILE;
                break;
        }
    }


    toggle_points_tool_visibility(visible) {
        if (visible) {
            $("#points-tool").removeClass("d-none")
        } else {
            $("#points-tool").addClass("d-none")
        }
    }

    // getters
    is_plugin_polygon_selected() {
        return $("#polygon").hasClass("activated");
    }
    is_plugin_point_selected() {
        return $("#point").hasClass("activated");
    }
    is_community_mode() {
        return selection_plugin.current_selected_tool === selection_plugin.SELECTION_TOOL_COMMUNITY;
    }
    is_point_mode() {
        return selection_plugin.current_selected_tool === selection_plugin.SELECTION_TOOL_POINT;
    }
    is_building_mode() {
        return selection_plugin.current_selected_tool === selection_plugin.SELECTION_TOOL_BUILDING;
    }

}



